import React from 'react';
import MinimumStockSettings from './minimum-stock-settings';
import { StoreTypeParam } from 'pages/shared/inventory-stock/types';

const KITCHEN_ALLOWED_STORE_TYPES: StoreTypeParam[] = [
  'kitchen-store',
  'prep-store',
  'brand-chef-store'
];
const KITCHEN_DROPDOWN_STORE_TYPES: StoreTypeParam[] = [
  'kitchen-store',
  'prep-store',
  'brand-chef-store'
];

const KitchenMinimumStockSettings = () => (
  <MinimumStockSettings
    defaultStoreType='kitchen-store'
    allowedStoreTypes={KITCHEN_ALLOWED_STORE_TYPES}
    dropdownStoreTypes={KITCHEN_DROPDOWN_STORE_TYPES}
    showStoreTypeDropdown
  />
);

export default KitchenMinimumStockSettings;
